module.exports = __webpack_public_path__ + "images/videoCaseStudy-nivea-results-photo-02.jpg?h=ce11cc9228082d1fd9d6fd7d6e6db9c2";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/nivea/videoCaseStudy-nivea-results-photo-02.jpg
// module id = 2116
// module chunks = 12 15